/* eslint-disable linebreak-style */
/* eslint-disable indent */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable import/no-cycle */
/* eslint-disable react/jsx-closing-tag-location */

import React from 'react';
import { withTranslation } from 'react-i18next';
import { Grid, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import DOMPurify from 'dompurify';

import DialogBox from '../../components/DialogBox';
import i18n from '../../i18n';
import store from '../../redux/store';
import userConstants from '../../services/Login/ActionType';
import { emit } from '../eventBus';

function ErrorDialogBox() {
  const { apiError, errorSyncRequired } = useSelector(state => state.authentication);

  const closeModal = async () => {
    try {
      const payload = { id: isValidationId, data: apiError?.messages?.[0]?.data || {} };
      const shouldEmit = isValidationId === 'item.missing.price' ||
        isValidationId === 'coupon.no.longer.available' ||
        isValidationId === 'coupon.not.valid' ||
        isValidationId === 'cart.item.not.available';
      if (shouldEmit) emit('ERROR_OK', payload);
    } catch (_) { /* no-op */ }
    store.dispatch({ type: userConstants.API_FAILS, payload: '' });
  };

  function extractDataWithRef(input) {
    if (input && typeof input === 'string') {
      const index = input.toLowerCase().indexOf('ref#');
      return index !== -1 ? input.slice(index).trim() : '';
    }
    return '';
  }
  const sanitizeHTML = (html) => ({ __html: DOMPurify.sanitize(html) });


  function extractDataRefWithInvalidError(errorObj) {
    if (errorObj?.id) {
      return `Reference #: ${errorObj.id}`;
    }
    return '';
  }

  const isValidationError = apiError?.data?.messages?.[0]?.['debug-message'];
  const isValidationId = apiError?.messages?.[0]?.['id'];
  const key = isValidationId ? `error.${isValidationId}` : '';
  const hasKey = key && i18n.exists(key);
  const hasErrorData = apiError?.messages?.[0]?.data;
  const message = hasKey ? i18n.t(key, hasErrorData || {}) : i18n.t('internalServerError.pageText');

  return (
    <Grid item xs={12} lg={12}>
      <DialogBox
        openDialog={apiError && !errorSyncRequired}
        title={
          isValidationError
            ? 'Oops! We ran into a problem!' :
            isValidationId ? '' : i18n.t('internalServerError.pageCaption')
        }
        cancelLable={i18n.t('switchAccount.orderType.ok')}
        onCancel={closeModal}
        width="xs"
        // Replace with sx or remove if not needed
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#000',
          fontWeight: 'bold',
          margin: 'auto',
        }}
      >
        {isValidationError ? (
          <Grid container>
            <Grid item xs={12}>
              <span className="f-16">
                We were unable to process your request at this time.
              </span>
            </Grid>

            <Grid item xs={12}>
              <Box mt={2} sx={{ whiteSpace: 'pre-line' }}>
                <span className="f-16">Details: {isValidationError}</span>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box mt={2}>
                <span className="f-16 interalerrorrefrence">
                  {extractDataRefWithInvalidError(apiError?.data?.messages?.[0])}
                </span>
              </Box>
            </Grid>
          </Grid>
        ) :

          i18n.t(`error.${isValidationId}`) ? (
            <>
              <Grid container className={isValidationId? 'errorDialogBox' : ''}>
                <Grid item xs={12}>
                  <span className="f-16"
                    dangerouslySetInnerHTML={sanitizeHTML(String(message).replace(/\n/g, '<br/>'))} />
                </Grid>
              </Grid>
            </>
          ) : <>
            <Grid container>
              <Grid item xs={12}>
                <span className="f-16">{i18n.t('internalServerError.pageText')}</span>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <span className="f-16 interalerrorrefrence">
                  {i18n.t(`${extractDataWithRef(apiError)}`)}
                </span>
              </Grid>
            </Grid>
          </>
        }
      </DialogBox>
    </Grid>
  );
}

export default (withTranslation()(ErrorDialogBox));
